import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18next';
import { loginTypes } from 'config/loginTypes';
import { gameRunningStatuses } from 'config/gameRunningStatuses';
import DialogSystem from 'client/components/DialogSystem';
import DialogLoginContainer from 'client/components/dialogLogin/DialogLoginContainer';
import { hasPassLoginCheckTriggerGame } from 'config/promoGameTypes';

const DialogInfoBeforeLoginTrigger = forwardRef((_, ref) => {
    const { gameRunningStatus } = useSelector(s => s.promoState);
    const { isLogin } = useSelector(s => s.userLoginState);
    const { loginMethod } = useSelector(s => s.settingPromo);
    const { type } = useSelector(s => s.promo);
    const [open, setOpen] = useState(false);
    let hasInfo = false;

    useImperativeHandle(ref, () => ({
        checkIsHasInfo: shouldOpen => {
            if (shouldOpen && hasInfo) {
                setOpen(true);
            }
            return hasInfo;
        }
    }));

    function onClose() {
        setOpen(false);
    }

    if (gameRunningStatus === gameRunningStatuses.NOT_PUBLISH) {
        hasInfo = true;
        const title = i18n.t('label.promo_not_publish');
        const body = i18n.t('label.try_again_later');
        return <DialogSystem title={title} body={body} closePopup={onClose} isOpen={open} />;
    } else if (gameRunningStatus === gameRunningStatuses.BEFORE) {
        hasInfo = true;
        const title = i18n.t('label.promo_not_start');
        const body = i18n.t('label.try_again_later');
        return <DialogSystem title={title} body={body} closePopup={onClose} isOpen={open} />;
    } else if (
        !isLogin &&
        loginMethod !== loginTypes.INSTAGRAM &&
        !hasPassLoginCheckTriggerGame(type)
    ) {
        hasInfo = true;
        return <DialogLoginContainer open={open} onClose={onClose} />;
    }

    return null;
});

DialogInfoBeforeLoginTrigger.displayName = 'DialogInfoBeforeLoginTrigger';

export default DialogInfoBeforeLoginTrigger;
